import { Component, OnInit, ViewChild, AfterViewInit, ViewChildren, PipeTransform, Pipe, Injectable, Directive, Inject, Input } from '@angular/core';

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import * as jsPDF from 'jspdf'
import * as html2canvas from "html2canvas";
import * as html2pdf from 'html2pdf.js'

import {Location} from '@angular/common';



import {

  ApexPlotOptions,
  ApexResponsive,

} from "ng-apexcharts";
import { color } from 'html2canvas/dist/types/css/types/color';
import { Chart } from 'node_modules/chart.js';

import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { GestureConfig } from 'owl-ng'
import { DateAdapter } from "@angular/material/core";
import {
  MatDateRangeSelectionStrategy,
  DateRange,
  MatDatepicker,
  MatDateRangePicker,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
  MatDatepickerInputEvent
} from "@angular/material/datepicker";

import Swal from 'sweetalert2/dist/sweetalert2.js'
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

import { PDFfile } from 'src/app/device/PDFfile';
import { Router } from '@angular/router';
import { TraslateService } from 'src/app/traslate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import 'hammerjs';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexFill,
  ApexXAxis,
  ApexDataLabels,
  ApexYAxis,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexAnnotations,
  ApexStroke,
  ApexMarkers,
  ApexGrid,
  ApexLegend
} from "ng-apexcharts";
import { TooltipArea } from '@swimlane/ngx-charts';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { MatMenuTrigger } from '@angular/material/menu';


@Injectable()
export class MaxRangeSelectionStrategy<D>
  implements MatDateRangeSelectionStrategy<D> {
  start: any;
  public delta: number;
  constructor(private _dateAdapter: DateAdapter<D>) { }

  selectionFinished(date: D, currentRange: DateRange<D>) {
    let { start, end } = currentRange;
    if (start == null || (start && end)) {
      start = date;
      end = null;
    } else if (end == null) {
      const maxDate = this._dateAdapter.addCalendarDays(start, this.delta);
      end = date ? (date > maxDate ? maxDate : date) : null;
    }

    return new DateRange<D>(start, end);
  }
  createPreview(
    activeDate: D | null,
    currentRange: DateRange<D>
  ): DateRange<D> {
    if (currentRange.start && !currentRange.end) {
      const maxDate = this._dateAdapter.addCalendarDays(
        currentRange.start,
        this.delta
      );
      const rangeEnd = activeDate
        ? activeDate > maxDate
          ? maxDate
          : activeDate
        : null;

      return new DateRange(currentRange.start, rangeEnd);
    }

    return new DateRange<D>(null, null);
  }
}

@Directive({
  selector: "[maxRange]",
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: MaxRangeSelectionStrategy
    }
  ]
})
export class MaxRangeDirective {
  constructor(
    @Inject(MAT_DATE_RANGE_SELECTION_STRATEGY)
    private maxRangeStrategy: MaxRangeSelectionStrategy<any>
  ) { }
  @Input() set maxRange(value: number) {
    this.maxRangeStrategy.delta = +value || 7;
  }
}


@Pipe({ name: 'formatTime' })
export class FormatTime implements PipeTransform {
  transform(value: number): string {
    let minutes: number = Math.trunc(value / 60);
    let hours: number = 0;
    let seconds: number = value - (minutes * 60);

    if (minutes >= 60) {
      hours = Math.trunc(minutes / 60);
      minutes = minutes - (hours * 60);
    }

    let response: string = "";

    if (hours > 0) {
      response = response + hours + " h ";
    }

    if (minutes > 0) {
      response = response + minutes + " min ";
    }

    if (seconds > 0) {
      response = response + seconds + " sec";
    }

    return response;
  }
}
export interface dataRep2 {

  value: number;
}






export type ChartOptions = {
  series: any;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  yaxis: any;
  tooltips: any;
  legend: ApexLegend;
  fill: ApexFill;
  colors: [
    "#00FF00",
    "#0000FF"
  ],
};

export type chartOptions2 = {
  series: any;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  responsive: ApexResponsive[];
  xaxis: ApexXAxis;
  yaxis: any;
  tooltips: any;
  legend: ApexLegend;
  fill: ApexFill;
  colors: [
    "#00FF00",
    "#0000FF"
  ],
};





@Component({
  selector: 'app-user-conducteur-details',
  templateUrl: './user-conducteur-details.component.html',
  styleUrls: ['./user-conducteur-details.component.scss']
})
export class UserConducteurDetailsComponent implements OnInit {




  minDate: Date = new Date(2010, 1, 1);
  maxDate: Date = new Date();

  myModel = true;
  @ViewChild('secondPaginator', { static: true }) secondPaginator: MatPaginator;
  @ViewChild('paginator', { static: true }) paginator: MatPaginator;
  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;
  public chartOptions2: Partial<chartOptions2>;
  chartOptions3: any;
  chartOptions5: any;
  chart1: boolean = true;
  chart2: boolean = true;
  chart3: boolean = true;
  chart4: boolean = true;
  chart5: boolean = true;
  series: any;
  xValues: any;
  yValues: any;
  name11: any;
  chartOptionsRadar: any;



  view1: any[] = [1400, 400];

  // options chart stacked bar 1 (sécurité)
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showLegend: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Date';
  showYAxisLabel: boolean = true;
  yAxisLabel: string = 'Durée (h)';
  animations: boolean = true;

  colorScheme = {
    domain: [" #51B373", "#FF4545", " #FBB950" ,"#FF9905"]};
  multi: {
    name: string; series: {
      name: string; value: number;
      heure_depart: string;
      heure_fin: string;

      distance: number;
      temps_inactivite: string;
      Score_moy_sec: number;
      Score_moy_eco: number
    }[];
  }[];



  hiddenContact: string = 'false';

  // options chart stacked bar 2 (économie)

  multi1: {
    name: any; series: {
      name: any; value: any;
      trip_start: any;
      trip_end: any;
      distance_traveled: any;
      idle_time: any;
      safety_score: any;
      eco_score: any
    }[];
  }[];

  vehiculetList: any = "";
  dataSourcet: any;
  repos: any;
  itemSelect2: any;
  hiddenContenu: string;
  selectedRowIndex2 = -1;
  vehicule_id: any;
  vehicule_plaque: any;
  id_boitier: any;
  myControl = new FormControl();
  displayedColumnst: string[] = ['position'];
  lengthTotal: any;
  reposSc: any;
  sc_tnd_sec: any;
  sc_tnd_eco: any;
  distanceEntreMan: any;
  tmpinactivite: any;
  scoreEc: any;
  scoreS: any;
  idConducteur: string;
  veh: any;
  plaque: any;
  marque: any;
  total_dist: any;
  moy_trajet_dist: any;
  moy_jour_dist: any;
  total_duree: any;
  moy_trajet_duree: any;
  moy_duree_jour: any;
  nbr_trajets: any;
  nbr_events: any;
  vitesse_moy: any;
  jrs_actives: any;
  pipe: DatePipe;
  listvehiculee: any;
  dataSource: any = [];
  finalDate: any;
  days: any;
  spinnerActive: boolean;

  URL: string;
  hiddenDetails: boolean = false;
  selectedRowIndex = -1;
  lentghS: number;
  avg_evo_sf_score: any;
  evo_sf_scores: any;
  evo_sf_score_cat: any;
  avg_evo_ec_score: any;
  evo_ec_scores: any;
  evo_ec_score_cat: any;





  reposRepartitionEC: any;
  reposRepartitionSF: any;
  unitsSF: any = [];
  reposRepartitionSF_avg: any;
  piePoint: any;
  pieStyle: any = [];
  pieColors: any = [];
  scoresSF: any = [];
  reposRepartitionEC_avg: any;
  unitsEC: any = [];
  scoresEC: any = [];
  pieStyleEC: any = [];
  pieColorsEC: any = [];
  reposRelationSF_EC: any;
  RelationEC_Avg: any;
  RelationSF_Avg: any;
  Relation_unitsEC_SF: any = [];
  series11: any[];
  formatVitesse: (val: any) => string;
  formatDist: (val: any) => string;
  unitsVitesse: string = "Vitesse moy";


  legendDist: boolean = false
  legendPositionDist: string = "below"
  minDist: any = 0
  maxDist: any = 0
  colorSchemeDist: any = {
    domain: ["#5AA454"]
  };
  reposRepartitionTpEvents_global: any = [];

  reposRepartitionTpEvents_unit: any = [];

  result: any[];
  typeEvenement: boolean;
  itemSelect: any[];
  customColors: any[];
  Events_Glob: any[];
  Events_unit: any[];
  Events_labels: any[];
  compagnie: any;
  reposHisto: any = [];
  any = [];
  col:any[]
col2:any[]
  ;
  singleDistance: { name: string; value: number; }[];


  legendVitesse: boolean = false
  legendPositionVitesse: string = "below"
  minVitesse: any = 0
  maxVitesse: any = 0
  colorSchemeVitesse: any = {
    domain: ["#84bdec"]
  };
  unitsDist: any = "Distance moy"
  smallSegments: any = 6
  bigSegments: any = 2
  singleVitesse: { name: string; value: number; }[];
  angleSpan: any = 180
  startAngle: any = -90
  urltest: string;
  reposScore: any;
  reposS: any;
  cond: any;
  id_cond: any;
  conducteur_id: any;
  listConducteurr: unknown[];

  constructor(private router: Router, private _snackBar: MatSnackBar, private http: HttpClient, private spinnerTrame: NgxSpinnerService ,private location: Location) {


    this.getcond_byId()

this.getCond()
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    this.idConducteur = this.location.path().split('/')[4]
    console.log(this.idConducteur)
    this.itemSelect2 = this.idConducteur
    console.log(this.itemSelect2)
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.executeFunction()

  }

getChartBar(e){


  this.multi1 = e

    var multi1 = this.multi1
    Object.assign(this, { multi1 });


}

  onSelect(event) {
    console.log(event);
    localStorage.setItem('filterValue', '')
    localStorage.setItem('trajet_history_conductor', JSON.stringify(event));
    console.log('trajet_history_conductor',event)
    localStorage.setItem('id_Conducteur',this.location.path().split('/')[4] )
    this.router.navigate(['user/conducteur/trajet/'+event.trip_id]);

  };

  /* onSelect(event ) {
    console.log(event.trip_id);
   localStorage.setItem('id_Vehicule',this.location.path().split('/')[4] )
    this.router.navigate(['user/vehicule/trajet/'+event.trip_id]);

  }; */

  applyFilter1(event: Event) {
    const filterValue2 = (event.target as HTMLInputElement).value;
    this.dataSourcet.filter = filterValue2.trim().toLowerCase();

    if (this.dataSourcet.paginator) {
      this.dataSourcet.paginator.firstPage();

    }


    this.hiddenContact = 'true'
  }
updateCharts(){

  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }


  this.getcond_byId()
  this.idConducteur = this.location.path().split('/')[4]

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };
  this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/scores/drivers/' + this.idConducteur, requestOptions).subscribe((response) => {

    var listconducteur: any = response

    this.lengthTotal = listconducteur.length

    this.reposSc = listconducteur
    this.repos = listconducteur.driver
    console.log(this.repos)

   this.cond= this.repos.name
     /* this.plaque = this.repos.plate
    this.marque = this.repos.brand*/
    this.compagnie = this.repos.company

    this.scoreS = this.reposSc?.global_safety_score
    this.scoreEc = this.reposSc?.global_eco_score
    this.distanceEntreMan = this.reposSc?.global_km_between_maneuvers
    this.tmpinactivite = this.reposSc?.global_idle_time
    this.sc_tnd_eco = this.reposSc?.global_eco_score_tendency
    this.sc_tnd_sec = this.reposSc?.global_safety_score_tendency



    this.avg_evo_sf_score = this.reposSc?.evolution_safety_score_chart.avg
    this.evo_sf_scores = this.reposSc?.evolution_safety_score_chart.evolution_safety_score.data
    this.evo_sf_score_cat = this.reposSc?.evolution_safety_score_chart.evolution_safety_score.categories

    this.avg_evo_ec_score = this.reposSc?.evolution_eco_score_chart.avg
    this.evo_ec_scores = this.reposSc?.evolution_eco_score_chart.evolution_eco_score.data
    this.evo_ec_score_cat = this.reposSc?.evolution_eco_score_chart.evolution_eco_score.categories

    this.reposRepartitionTpEvents_global = this.reposSc?.global_repartition_events
    this.reposRepartitionTpEvents_unit = this.reposSc?.repartition_events
    console.log(this.reposRepartitionTpEvents_global)
    console.log(this.reposRepartitionTpEvents_unit)

this.reposHisto=this.reposSc?.trips_details





    this.Events_Glob = []
    this.Events_unit = []
    this.Events_labels = []

    for (let e in this.reposRepartitionTpEvents_global) {
      this.Events_Glob.push(this.reposRepartitionTpEvents_global[e].value)
      this.Events_labels.push(this.reposRepartitionTpEvents_global[e].name)
      console.log(this.Events_Glob)

    }
    for (let i in this.reposRepartitionTpEvents_unit) {
      this.Events_unit.push(this.reposRepartitionTpEvents_unit[i].value)
      console.log(this.Events_unit)

    }






    this.getchrt2(this.evo_ec_scores, this.evo_ec_score_cat, this.avg_evo_ec_score)
    this.getchrt3(this.evo_sf_scores, this.evo_sf_score_cat, this.avg_evo_sf_score)
    this.getRadarChart(this.Events_labels, this.Events_Glob, this.Events_unit, this.cond, this.compagnie);
    this.getChartBar(this.reposHisto)

  },
  (error) => {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Un problème est survenu! '+error,

    })


  })


}



getCond(){
  const headerDict = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Headers': 'Content-Type',
  }

  const requestOptions = {
    headers: new HttpHeaders(headerDict),
  };

  this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id + '/drivers' ,requestOptions).subscribe((response)=>{

    console.log(response)

     var conducteurListt:any =response


     this.repos =  conducteurListt.drivers

     this.dataSourcet = new MatTableDataSource(this.repos) ;




 this.dataSourcet.paginator = this.secondPaginator;




},
(error) => {
  Swal.fire({
    icon: 'error',
    title: 'Oops...',
    text: 'Un problème est survenu! '+error,

  })


})




  }

  getcond_byId(){
    this.idConducteur = this.location.path().split('/')[4]
    console.log(this.idConducteur)
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
      this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/scores/drivers/'+this.idConducteur ,requestOptions).subscribe((response)=>{

        var listConducteurr:any =response

        this.lengthTotal = listConducteurr.length


        this.repos =  listConducteurr.driver
        console.log(this.repos)


        this.reposS =  listConducteurr.scores
        this.lentghS = this.reposS.length


   if (this.lentghS != 0){

    this.total_dist=this.reposS.distance_traveled
    this.moy_trajet_dist=this.reposS.avg_distance_per_trip
    this.moy_jour_dist=this.reposS.avg_distance_per_day

    this.total_duree=this.reposS.trip_duration
    this.moy_trajet_duree=this.reposS.avg_duration_per_trip
    this.moy_duree_jour=this.reposS.avg_duration_per_day



    this.nbr_trajets=this.reposS.trips
    this.nbr_events=this.reposS.nb_events
    this.vitesse_moy=this.reposS.avg_speed
    this.jrs_actives= this.reposS.active_days

   }
   else {
    this.total_dist= "0"
    this.moy_trajet_dist= "0"
    this.moy_jour_dist= "0"

    this.total_duree= "0"
    this.moy_trajet_duree= "0"
    this.moy_duree_jour= "0"



    this.nbr_trajets= "0"
    this.nbr_events= "0"
    this.vitesse_moy= "0"
    this.jrs_actives= "0"
   }


       this.cond=this.repos.name
       this.id_cond=this.repos.id

       console.log(this.total_dist)


       },
       (error) => {
         Swal.fire({
           icon: 'error',
           title: 'Oops...',
           text: 'Un problème est survenu! '+error,

         })


       })

  }




  getItemDetails2(e) {


    this.itemSelect2 =e.id;
    this.conducteur_id =e.id

    let url = 'user/conducteur/details/'+ this.itemSelect2
    //this.router.navigate([url]);

    this.location.go( url );
    this.location.replaceState( url );
this.hiddenContenu = 'jkhjk';

    this.selectedRowIndex2 = e.id;

    //this.updateCharts()


 this.executeFunction()

  }
  async refrech() {

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    // this.http.get(environment.apiUrl+'/companies/'+ JSON.parse(localStorage.getItem('currentUser')).company_id +'/scores/vehicles/all' ,requestOptions).subscribe((response)=>{
    this.http.get(environment.apiUrl + '/companies/' + JSON.parse(localStorage.getItem('currentUser')).company_id + '/drivers', requestOptions).subscribe((response) => {

      console.log(response)

      var conducteurtListt: any = response


      this.repos = conducteurtListt.drivers

      this.dataSourcet = new MatTableDataSource(this.repos);




      this.dataSourcet.paginator = this.secondPaginator;


      this.avg_evo_sf_score = this.reposSc?.evolution_safety_score_chart?.avg
      this.evo_sf_scores = this.reposSc?.evolution_safety_score_chart.evolution_safety_score?.data
      this.evo_sf_score_cat = this.reposSc?.evolution_safety_score_chart.evolution_safety_score?.categories

      this.avg_evo_ec_score = this.reposSc?.evolution_eco_score_chart?.avg
      this.evo_ec_scores = this.reposSc?.evolution_eco_score_chart.evolution_eco_score?.data
      this.evo_ec_score_cat = this.reposSc?.evolution_eco_score_chart.evolution_eco_score?.categories





      this.getchrt2(this.evo_ec_scores, this.evo_ec_score_cat, this.avg_evo_ec_score)
      this.getchrt3(this.evo_sf_scores, this.evo_sf_score_cat, this.avg_evo_sf_score)

      this._snackBar.open('la liste des véhicules est actualisée ', 'Fermer', {
        duration: 2500,

      });

    },
    (error) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Un problème est survenu! '+error,

      })


    })


  }

  public hiddencontenu2() {
    this.hiddenContact = 'jkhjk';
  }

  onClick($event) {
    console.log('hello')
  }
 /*  onExportClick() {
    console.log('hello')
    const options = {
      filename: 'test_export.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'landscape' }

    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf()
      .from(content)
      .set(options)
      .save();
  } */

  showChart1() {

    this.chart1 = !this.chart1;
  }

  showChart2() {

    this.chart2 = !this.chart2;
  }

  showChart3() {

    this.chart3 = !this.chart3;
  }
  showChart4() {

    this.chart4 = !this.chart4;
  }
  showChart5() {

    this.chart5 = !this.chart5;
  }


  ngOnInit(): void {


  }

  getRadarChart(events, ev_global, ev_veh, veh, compagnie) {

    this.chartOptionsRadar = {
      series: [{
        name: veh,
        data: ev_veh,
      },
      {
        name: compagnie,
        data: ev_global,
      }],
      chart: {
        height: 400,
        type: 'radar',
      },
      dataLabels: {
        enabled: true
      },
      plotOptions: {
        radar: {
          size: 140,
          polygons: {
            strokeColors: '#e9e9e9',
            fill: {
              colors: ['#f8f8f8', '#fff']
            }
          }
        }
      },
      title: {
        text: 'Radar with Polygon Fill'
      },
      colors: ['#FF4560', '#EFC353'],
      markers: {
        size: 4,
        colors: ['#fff'],
        strokeColor: '#FF4560',
        strokeWidth: 2,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val
          }
        }
      },
      xaxis: {
        categories: events
      },
      yaxis: {
        tickAmount: 7,
        labels: {
          formatter: function (val, i) {
            if (i % 2 === 0) {
              return val
            } else {
              return ''
            }
          }
        }
      }
    };



  }

  hiddencontenu() {
    this.hiddenContact = 'true';
  }
  getchrt2(e, e2, avg) {
    this.chartOptions5 = {
      series: [
        {
          name: '<img src="https://img.icons8.com/color/20/000000/natural-food.png"/> <b> Score économie </b>',
          data: e
        }
      ],
      chart: {
        height: '400px',
        width: '100%',
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: true
        }
      },
      colors: ["#1fb141", "#545454"],
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "smooth"
      },

      title: {
        text: "",
        align: "left"
      },
      grid: {
        show: false,
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0
        }
      },
      markers: {
        size: 6,
        hover: {
          size: 16
        }
      },
      xaxis: {
        type: "category",
        categories: e2,
        title: {
          text: "Date"
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        title: {
          text: "Score d'économie (%)"
        }
      }
      , tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        }, marker: {
          show: false,
        },
        y: {

          formatter: (values) => {
            return values + ' %   <img src="https://img.icons8.com/color/20/000000/average-value.png"/>  Moyenne: ' + avg + '%';
          },
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5
      }
      ,
      annotations: {
        yaxis: [
          {
            y: avg,
            borderColor: '#00E396',
            label: {
              borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396'
              },
              text: 'Moyenne ' + avg + '%'
            }
          }
        ]
      },

    };

  }

  getchrt3(e, e2, avg) {
    this.chartOptions3 = {
      series: [
        {
          name: ' <img src="https://img.icons8.com/color/20/000000/warning-shield.png"/> <b> Score sécurité </b>',
          data: e
        }
      ],
      chart: {
        height: '400px',
        width: '100%',
        type: "line",
        dropShadow: {
          enabled: true,
          color: "#000",
          top: 18,
          left: 7,
          blur: 10,
          opacity: 0.2
        },
        toolbar: {
          show: true
        }
      },
      colors: ["#ffc107", "#545454"],
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: "smooth"
      },
      title: {
        text: "",
        align: "left"
      },
      grid: {
        show: false,
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0
        }
      },
      markers: {
        size: 6,
        hover: {
          size: 16
        }
      },
      xaxis: {
        //  type: "datetime",
        type: "category",
        categories: e2,
        title: {
          text: "Date"
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        title: {
          text: "Score sécurité (%)"
        },

      }
      , tooltip: {
        enabled: true,
        onDatasetHover: {
          highlightDataSeries: true,
        }, marker: {
          show: false,
        },
        y: {

          formatter: (values) => {
            return values + ' %  <img src="https://img.icons8.com/color/20/000000/average-value.png"/> Moyenne: ' + avg + '%';
          },
        }
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        floating: true,
        offsetY: -25,
        offsetX: -5
      },
      annotations: {
        yaxis: [
          {
            y: avg,
            borderColor: '#00E396',
            label: {
              borderColor: '#00E396',
              style: {
                color: '#fff',
                background: '#00E396'
              },
              text: 'Moyenne ' + avg + '%'
            }
          }
        ]
      },
    }

  }
  downloadCanvas(event) {
    var anchor = event.target;
    // get the canvas
    anchor.href = document.getElementsByTagName('canvas')[0].toDataURL();
    anchor.download = "test.png";
    const documentDefinition = { content: 'This is a sample PDF printed with pdfMake' };
    pdfMake.createPdf(documentDefinition).open();
  }



  rangeForm = new FormGroup({

    start: new FormControl(new Date(localStorage.getItem('startDateValue'))),
    end: new FormControl(new Date(localStorage.getItem('endDateValue'))),
  });

  executeFunction(){
 console.log(this.rangeForm)

    this.addNewDate(this.rangeForm)

  }

  addNewDate(e) {



    var DateStart = new Date(e.value.start)?.toString().split('(')[0];
    //this.minDate = new Date(e.value.start)


    var DateEnd2 = new Date(e.value.end)?.toISOString();
    var DateEnd = new Date(e.value.end)?.toString().split('(')[0];
    console.log(DateEnd2, DateStart, DateEnd)

    if (DateEnd2 != "1970-01-01T00:00:00.000Z") {

      this.getdd(DateStart, DateEnd)
    } else {
      // this.rangeForm.reset();
    }
  }

  getdd(e1, e2) {

    this.idConducteur = this.location.path().split('/')[4]
    console.log(this.idConducteur)

    this.result = []
    console.log(this.result)
    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    this.typeEvenement = false
    this.URL = environment.apiUrl + "/companies/" + JSON.parse(localStorage.getItem('currentUser')).company_id + "/scores/drivers/" + this.idConducteur + "/filter/" + e1 + '~' + e2

    this.spinnerActive = true
    this.spinnerTrame.show();
    this.http.get(this.URL, requestOptions).subscribe((response) => {
      this.itemSelect = []

      this.hiddenDetails = false
      this.selectedRowIndex = -1;
      this.dataSource = new MatTableDataSource(this.listConducteurr);

      // this.ELEMENT_DATAFILTER = JSON.stringify(response)
      var list: any = response


      console.log(list.driver)
      this.dataSource = new MatTableDataSource(list.driver);
      console.log(this.dataSource)

      this.dataSource.paginator = this.paginator;



      this.reposSc = list


      this.cond = list.driver.name
      /*this.plaque = this.repos.plate
      this.marque = this.repos.brand*/
      this.compagnie = list.driver.company

      //events type Repartition:

      this.reposRepartitionTpEvents_global = list?.global_repartition_events
      console.log(this.reposRepartitionTpEvents_global)
      this.reposRepartitionTpEvents_unit = this.reposSc.repartition_events

      //Relation Safety-Economy score



      this.scoreS = this.reposSc?.global_safety_score
      this.scoreEc = this.reposSc?.global_eco_score
      this.distanceEntreMan = this.reposSc?.global_km_between_maneuvers
      this.tmpinactivite = this.reposSc?.global_idle_time
      this.sc_tnd_eco = this.reposSc?.global_eco_score_tendency
      this.sc_tnd_sec = this.reposSc?.global_safety_score_tendency




      this.avg_evo_sf_score = this.reposSc?.evolution_safety_score_chart.avg
      this.evo_sf_scores = this.reposSc?.evolution_safety_score_chart.evolution_safety_score.data
      this.evo_sf_score_cat = this.reposSc?.evolution_safety_score_chart.evolution_safety_score.categories

      this.avg_evo_ec_score = this.reposSc?.evolution_eco_score_chart.avg
      this.evo_ec_scores = this.reposSc?.evolution_eco_score_chart.evolution_eco_score.data
      this.evo_ec_score_cat = this.reposSc?.evolution_eco_score_chart.evolution_eco_score.categories


      this.reposScore=list?.scores

      this.lentghS=this.reposScore?.length

      if (this.lentghS != 0) {

        this.total_dist = this.reposScore?.distance_traveled
        this.moy_trajet_dist = this.reposScore?.avg_distance_per_trip
        this.moy_jour_dist = this.reposScore?.avg_distance_per_day

        this.total_duree = this.reposScore?.trip_duration
        this.moy_trajet_duree = this.reposScore?.avg_duration_per_trip
        this.moy_duree_jour = this.reposScore.avg_duration_per_day



        this.nbr_trajets = this.reposScore.trips
        this.nbr_events = this.reposScore.nb_events
        this.vitesse_moy = this.reposScore.avg_speed
        this.jrs_actives = this.reposScore.active_days
      }
      else {

        this.total_dist = "0"
        this.moy_trajet_dist = "0"
        this.moy_jour_dist = "0"

        this.total_duree = "0"
        this.moy_trajet_duree = "0"
        this.moy_duree_jour = "0"



        this.nbr_trajets = "0"
        this.nbr_events = "0"
        this.vitesse_moy = "0"
        this.jrs_actives = "0"

      }



      this.reposHisto=this.reposSc.trips_details


      let result: any[] = [];
      let result1 : any[] = [];
      for(let e in this.reposHisto){
        for(let i in this.reposHisto[e].series){

          //console.log(this.reposHisto[e].series[i].value)
         if (this.reposHisto[e].series[i].safety_score < 55){
            console.log(this.reposHisto[e].series[i].name)

            //custumcolors.push( "#E05A61");
            result.push({"name": this.reposHisto[e].series[i].name.toString(),"value": "#E05A61"});
            //console.log(custumcolors)

         }
        else if( this.reposHisto[e].series[i].safety_score < 75){
            console.log(this.reposHisto[e].series[i].name)
            result.push({"name": this.reposHisto[e].series[i].name.toString(),"value": "#FBB950"});

            //custumcolors.push("#ffcc36");
        }
        else if ( this.reposHisto[e].series[i].safety_score < 101){
            console.log(this.reposHisto[e].series[i].name)
            result.push({"name": this.reposHisto[e].series[i].name.toString(),"value": "#51B373"});
            //custumcolors.push( "#35b854");

        }

        if (this.reposHisto[e].series[i].eco_score < 55){
          //console.log(this.reposHisto[e].series[i].name)

          //custumcolors.push( "#E05A61");
          result1.push({"name": this.reposHisto[e].series[i].name.toString(),"value": "#E05A61"});
          //console.log(custumcolors)

       }
      else if( this.reposHisto[e].series[i].eco_score < 75){
          //console.log(this.reposHisto[e].series[i].name)
          result1.push({"name": this.reposHisto[e].series[i].name.toString(),"value": "#FBB950"});

          //custumcolors.push("#ffcc36");
      }
      else if ( this.reposHisto[e].series[i].eco_score < 101){
          //console.log(this.reposHisto[e].series[i].name)
          result1.push({"name": this.reposHisto[e].series[i].name.toString(),"value": "#51B373"});
          //custumcolors.push( "#35b854");

      }

        }
      this.col=result
      console.log(this.col)

      this.col2=result1
      console.log(this.col2)

  }




      this.Events_Glob = []
      this.Events_unit = []
      this.Events_labels = []

      for (let e in this.reposRepartitionTpEvents_global) {
        this.Events_Glob.push(this.reposRepartitionTpEvents_global[e].value)
        this.Events_labels.push(this.reposRepartitionTpEvents_global[e].name)
        console.log(this.Events_Glob)

      }
      for (let i in this.reposRepartitionTpEvents_unit) {
        this.Events_unit.push(this.reposRepartitionTpEvents_unit[i].value)
        console.log(this.Events_unit)

      }



      this.getchrt3(this.evo_sf_scores, this.evo_sf_score_cat, this.avg_evo_sf_score)
      this.getchrt2(this.evo_ec_scores, this.evo_ec_score_cat, this.avg_evo_ec_score)
      this.getRadarChart(this.Events_labels, this.Events_Glob, this.Events_unit, this.cond, this.compagnie);
      this.getChartBar(this.reposHisto)


      this._snackBar.open('Filtrage par  date effectuer' + e1 + ' à ' + e2, 'Fermer', {
        duration: 2500,

      });



      //let result: any[] = [];
      for (let i = 0; i < this.reposRepartitionTpEvents_global?.length; i++) {
        if (this.reposRepartitionTpEvents_global[i]?.value < 55) {
          this.result.push({ "name": this.reposRepartitionTpEvents_global[i]?.name, "value": "#E05A61" });
        }
        else if (this.reposRepartitionTpEvents_global[i]?.value < 75) {
          this.result.push({ "name": this.reposRepartitionTpEvents_global[i]?.name, "value": "#FBB950" });
        }
        else if (this.reposRepartitionTpEvents_global[i]?.value < 101) {
          this.result.push({ "name": this.reposRepartitionTpEvents_global[i]?.name, "value": "#51B373" });
        }
      }

      this.customColors = this.result;
      console.log(this.result)

      this.unitsSF = []
      this.scoresSF = []
      for (let U in this.reposRepartitionSF) {

        console.log(U)

        this.unitsSF.push(this.reposRepartitionSF[U].drivers)
        this.scoresSF.push(this.reposRepartitionSF[U].interval + '%')

        console.log(this.unitsSF)

        if (this.reposRepartitionSF[U].avg_interval < 50) {
          var style = "verticalLines"
          var colors = '#FF4545'
        } else if (this.reposRepartitionSF[U].avg_interval < 75) {
          var style = "squares"
          var colors = '#FBB950'
        } else {
          var style = "horizontalLines"
          var colors = '#51B373'
        }

        this.pieStyle.push(
          style


        );


        this.pieColors.push(
          colors);

      }


      this.unitsEC = []
      this.scoresEC = []


      for (let U in this.reposRepartitionEC) {

        console.log(U)

        this.unitsEC.push(this.reposRepartitionEC[U].drivers)
        this.scoresEC.push(this.reposRepartitionEC[U].interval + '%')
        console.log(this.unitsEC)

        if (this.reposRepartitionEC[U].avg_interval < 50) {
          var style = "verticalLines"
          var colors = '#FF4545'
        } else if (this.reposRepartitionEC[U].avg_interval < 75) {
          var style = "squares"
          var colors = '#FBB950'
        } else {
          var style = "horizontalLines"
          var colors = '#51B373'
        }

        this.pieStyleEC.push(
          style


        );


        this.pieColorsEC.push(
          colors);

      }




      this.Relation_unitsEC_SF = []
      this.series11 = []
      for (let U in this.reposRelationSF_EC) {

        console.log(U)

        this.Relation_unitsEC_SF.push(this.reposRelationSF_EC[U])

        console.log(this.Relation_unitsEC_SF)

        for (let i in this.Relation_unitsEC_SF) {

          this.series11.push([this.reposRelationSF_EC[U].eco_score,
          this.reposRelationSF_EC[U]?.safety_score,
            20,
          this.reposRelationSF_EC[U]?.name
          ]);
        }
        console.log(this.series11)




      }
      this.spinnerTrame.hide();
      this.spinnerActive = false
      this.typeEvenement = true

    },
    (error) => {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Un problème est survenu! '+error,

      })
      this.spinnerTrame.hide();
      this.spinnerActive = false

    })











  }











  getFilterChoise(filterdte) {
    this.rangeForm.reset();
    (<HTMLInputElement>document.getElementById('getdt')).value = ''

    const headerDict = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    }

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };

    this.pipe = new DatePipe('en');
    this.days = this.pipe.transform(new Date(), 'M/d/yyyy');
    console.log(this.days + new Date())

    var date = new Date();
    date.setDate(date.getDate() - filterdte);

    this.finalDate = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    console.log((new Date).toString().substr(0, 24), date.toString().substr(0, 24))
    var periodeFilter = date.toString().substr(0, 24) + '~' + (new Date).toString().substr(0, 24)

    this.getdd(date.toString().substr(0, 24), (new Date).toString().substr(0, 24))



  }

   getChart(events, ev_global, ev_veh, veh, compagnie) {

    // tslint:disable-next-line:prefer-const
    let ctx = document.getElementById('myChart');
    console.log('dgfhdfgkjsd' + ctx)
    // tslint:disable-next-line:prefer-const
    let myChart = new Chart(ctx, {
      type: 'radar',
      data: {
        labels: events,
        datasets: [{
          label: compagnie,
          fill: false,
          data: ev_global,
          backgroundColor: [
            'rgb(245, 89, 82 ,0)',


          ],
          borderColor: [
            'rgb(245, 89, 82 ,1)',


          ],
          borderWidth: 1,
          pointStyle: 'circle',
          pointRadius: '5',
          pointBackgroundColor: 'rgb(245, 89, 82 ,1)',
          pointBorderColor: 'rgb(245, 89, 82 ,1)'
        },


        {
          label: veh,
          fill: true,
          data: ev_veh,
          backgroundColor: [
            'rgb(210, 34, 84,0)',


          ],
          borderColor: [
            'rgb(210, 34, 84 ,1)',

          ],
          borderWidth: 1,
          pointStyle: 'circle',
          pointRadius: '5',
          pointBackgroundColor: 'rgb(210, 34, 84,1)',
          pointBorderColor: 'rgb(210, 34, 84 ,1)'
        }
        ]
      },
      options: {
        tooltips: {
          custom(tooltip) {
            if (!tooltip) { return; }
            // disable displaying the color box;
            tooltip.displayColors = false;
          },
          callbacks: {
            title(tooltipItem, data) {
              return data.labels[tooltipItem[0].index];
            }, label(tooltipItem, data) {
              return data.datasets[tooltipItem.datasetIndex].label + ':' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] + '€';

            },


          },

          yAlign: 'bottom',
          backgroundColor: 'rgb(50, 61, 65)',

        },
        layout: {
          padding: {
            left: 10,
            right: 0,
            top: 0,
            bottom: 0
          },

        },
        legend: {
          display: true,
          position: 'left',
          align: 'start',

          labels: {





          }

        }


      }
    })
  }
}
